// Fonctions utilitaires pour le formatage des dates ISO en français

// Fonction utilitaire pour convertir n'importe quelle entrée en Date JS valide
function toValidDate(input: string | Date | number | undefined | null): Date | null {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
  if (typeof input === 'number') {
    const d = new Date(input);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof input === 'string') {
    // Si c'est déjà un format ISO ou YYYY-MM-DD, new Date sait le parser
    const d = new Date(input);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}

/**
 * Convertit une date ISO (ou Date JS) en format JJ/MM
 * @param isoString string | Date | number
 * @returns string
 */
export function formatDateShort(isoString: string | Date | number): string {
  const d = toValidDate(isoString);
  if (!d) return '';
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  return `${day}/${month}`;
}

/**
 * Convertit une date ISO (ou Date JS) en format JJ/MM/AAAA - HH:MM:SS
 * @param isoString string | Date | number
 * @returns string
 */
export function formatDateFull(isoString: string | Date | number): string {
  const d = toValidDate(isoString);
  if (!d) return '';
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const seconds = d.getSeconds().toString().padStart(2, '0');
  return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
}

/**
 * Convertit une date ISO (ou Date JS) en ISO string (YYYY-MM-DDTHH:mm:ss.sssZ)
 * @param isoString string | Date | number
 * @returns string
 */
export function toISOString(isoString: string | Date | number): string {
  const d = toValidDate(isoString);
  return d ? d.toISOString() : '';
}

/**
 * Convertit une date ISO (ou Date JS) en format YYYY-MM-DD
 * @param isoString string | Date | number
 * @returns string
 */
export function formatDateISO(isoString: string | Date | number): string {
  const d = toValidDate(isoString);
  if (!d) return '';
  const year = d.getFullYear();
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
